
import ArrowSwapHorizontal from "../../../assets/filled/ArrowSwapHorizontal.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowSwapHorizontalIcon({ className, dataTestid = "ArrowSwapHorizontalIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowSwapHorizontal data-testid={dataTestid} className={classes} {...rest} />
  );
}
